
import React, { createContext, useContext, useState } from 'react';

const SpaceContext = createContext();

export const SpaceContextProvider = ({ children }) => {

  const [teams, setTeams] = useState([]);
  const [projects, setProjects] = useState([]);
  const [shirts, setShirts] = useState([]);
  const [teamsProjects, setTeamsProjects] = useState([]);

  return (
      <SpaceContext.Provider value={{ 
          teams, projects, shirts, teamsProjects, 
          setTeams, setProjects, setShirts, setTeamsProjects }}>
        {children}
      </SpaceContext.Provider>
    );
}

export const useSpace = () => useContext(SpaceContext);
